import React from 'react';
import { array, object } from 'prop-types';

import { bem, DIAL_MIN_ID, DIAL_MAX_ID } from './index';

export const Labels = (props) => {
    const { container, formatValues, rangeAsValue } = props;
    if (!container) {
        return null;
    }
    const [min, max] = formatValues && typeof formatValues === 'function' ? formatValues(rangeAsValue) : rangeAsValue;
    return (
        <div className={bem('labels')}>
            <div className={bem('label', 'min')}>
                <label htmlFor={DIAL_MIN_ID}>{`${min}`}</label>
            </div>
            <div className={bem('label', 'max')}>
                <label htmlFor={DIAL_MAX_ID}>{`${max}`}</label>
            </div>
        </div>
    );
};

Labels.propTypes = {
    container: object,
    rangeAsValue: array,
};
